import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MUITable from "../../../Common/MUITable";
import { TableLoader } from "../../../Common/ShimmerLoader";
import useGrievanceReportStore from "./store/grievanceReportStore";
import { ExportGrievanceDetailedReport } from "./ExportGrievanceDetailedReport";
import isGHMC from "../../../Common/helper/helpar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import GrievanceDetailedReportModal from "./grievanceDetailedReportModal";
export const GrievanceDetailedReport = () => {
    const {
        grievanceReportData,
        loading,
        grievanceItemsDropedownList,
        fetchgrievanceDetailedReport,
        grievanceItemList,
        setSelectedComplaintNo,
        selectComplaintNo,
        setStatus,
        selectedStatus,
        setSelectedIEName,
        selectIEName } = useGrievanceReportStore();
    const isProd = isGHMC()
    const [modalShow, setModalShow] = useState(false);
    const [selectedGrievanceData, setSelectedGrievanceData] = useState(null);
    console.log(grievanceItemsDropedownList)

    useEffect(() => {
        // Initial fetch without filters
        fetchgrievanceDetailedReport();
    }, []);

    // Function to fetch data with filters when clicking search
    const handleSearch = () => {
        fetchgrievanceDetailedReport({
            complaintNo: selectComplaintNo,
            status: selectedStatus,
            ieEngineerId: selectIEName

        });
    };

    const grievanceReportHeaderColumns = [
        { label: "Complaint Number", field: "complaintNo" },
        { label: "IE Engineer Name", field: "ieEngineerName" },
        { label: "KPI", field: "kpiCategoryName" },
        { label: "Description", field: "description" },
        { label: "Status", field: "status" },

        {
            label: "Action",
            field: "action",
            render: (row, index) => (
                <div className="d-flex gap-2 justify-content-center" >
                    <button
                        className={`${index % 2 === 0 ? "bg-F8CCCD" : "bg-ddefff"} 
                          ${isProd ? "edit-ghmc" : "edit-swm"}`}
                        onClick={() => {
                            setSelectedGrievanceData(row); // Set selected row data
                            setModalShow(true); // Open modal
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} />
                    </button>
                </div>
            ),
        },
    ];

    const sortedGrievanceReportData = [...grievanceReportData].sort((a, b) => {
        if (a.status === "Closed") return 1;
        if (b.status === "Closed") return -1;
        return 0;
    });
    

    return (
        <div style={{ width: "100%" }}>
            <div className="content">
                <div className="page-content">
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div className="d-flex align-items-end gap-2 mb-2">
                            {/* Status Filter */}
                            <div style={{ width: "200px" }}>
                                <div className="form-group-filter">
                                    <label className="form-label" style={{ marginBottom: "-2px" }}>Status</label>
                                    <select
                                        id="status-filter-input"
                                        name="status"
                                        className="form-select bg-white"
                                        value={selectedStatus}
                                        onChange={(e) => setStatus(e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        <option value="open">Open</option>
                                        <option value="close">Close</option>
                                        <option value="reopen">Reopen</option>
                                    </select>
                                </div>
                            </div>

                            <div style={{ width: "200px" }}>
                                <div className="form-group-filter">
                                    <label className="form-label" style={{ marginBottom: "-2px" }}>Complaint No</label>
                                    <select
                                        className="form-select bg-white"
                                        value={selectComplaintNo}
                                        onChange={(e) => setSelectedComplaintNo(e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        {grievanceItemList.map((name, index) => (
                                            <option key={index} value={name}>
                                                {name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div style={{ width: "200px" }}>
                                <div className="form-group-filter">
                                    <label className="form-label" style={{ marginBottom: "-2px" }}>IE Name:</label>
                                    <select
                                        className="form-select bg-white"
                                        value={selectIEName}
                                        onChange={(e) => setSelectedIEName(e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        {[...new Map(grievanceItemsDropedownList.map(item => [item.id, item])).values()]
                                            .map((item, index) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}

                                    </select>
                                </div>
                            </div>

                            {/* Search Button */}
                            <button className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                                onClick={handleSearch}
                            >
                                Search
                            </button>
                        </div>
                        <div className="mt-4 d-flex">
                            {/* <div></div> */}
                            <ExportGrievanceDetailedReport />
                        </div>
                    </div>


                    {/* Data Table Section */}
                    <div className="card mt-3">
                        <div className="card-body">
                            <div className="top-header p-2"
                                style={{ backgroundColor: "#D7D7D7", fontWeight: "600", borderBottom: "1px solid #DDDDDD" }}>
                                <span>Grievance Detailed Report</span>
                            </div>
                            {/* Filter & Search Section */}

                            <MUITable loading={loading}
                                    needSRNumber
                                    columns={grievanceReportHeaderColumns}
                                    rows={grievanceReportData}
                                    tableHeight={500}
                                />
                        </div>

                        <GrievanceDetailedReportModal
                            show={modalShow}
                            handleClose={() => {
                                setModalShow(false);
                                setSelectedGrievanceData(null); // Clear selected data when closing modal
                            }}
                            selectedGrievanceData={selectedGrievanceData}
                        />

                    </div>
                </div>
            </div>
        </div>
    );
};
